/**
 * Renders the Explore All btn
 *
 * Copyright (c) 2022 Propellant Software Corp
 * Author: Kelvin Nguyen
 */

import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { Button } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Link from 'client/shared/js/components/Link'
import styles from './ExploreButton.module.scss'

const ExploreButton = ({
  url,
  color = 'link',
  dark = false,
  disableArrow
}) => {
  return (
    <Link to={url} anchor>
      <Button color={color} className={cx(styles['explore-btn'], {
        dark: !!dark
      })}>
        Explore all {!disableArrow && <FontAwesomeIcon icon={['fal', 'arrow-right']} />}
      </Button>
    </Link>
  )
}

ExploreButton.propTypes = {
  url: PropTypes.string,
  color: PropTypes.string,
  dark: PropTypes.bool,
  disableArrow: PropTypes.bool
}

export default ExploreButton
